import { render, staticRenderFns } from "./ComboItem.vue?vue&type=template&id=0a0bdeea&"
import script from "./ComboItem.vue?vue&type=script&lang=js&"
export * from "./ComboItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports